"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.seriallyPromise = void 0;
/**
 * Runs promises serially. Accepts an array of functions returning promises.
 *
 * .then() - called when evrth has been called sequentially and without ANY error.
 *
 * .catch(error) - called when any of promises has been resolved with error.
 * [error] - first rejected error.
 * */
function seriallyPromise(promiseFunctions) {
    let chain = Promise.resolve();
    promiseFunctions.forEach((promiseFunction) => {
        chain = chain.then(promiseFunction);
    });
    return chain;
}
exports.seriallyPromise = seriallyPromise;
//# sourceMappingURL=seriallyPromise.js.map